module.exports = __webpack_public_path__ + "static/media/Floor 1_forklift.a2b6885b.svg";